import { render, staticRenderFns } from "./task_step_ageber.vue?vue&type=template&id=e4571524&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./task_step_ageber.vue?vue&type=script&lang=js"
export * from "./task_step_ageber.vue?vue&type=script&lang=js"
import style0 from "./task_step_ageber.vue?vue&type=style&index=0&id=e4571524&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4571524",
  null
  
)

export default component.exports